<template>
    <header class="header d-md-flex flex-row justify-content-center">
        <div class="d-md-flex flex-column flex-md-row justify-content-between py-3 py-md-4"
        style="width: 100%; max-width: 1360px; padding-left: 20px; padding-right: 20px;">
            <div class="text-left">
                <router-link to="/">
                    <img :src="require('../assets/logo.svg')" alt="">
                </router-link>
            </div>
            <!-- <nav class="menubar">
                <ul class="menubar-ul d-md-flex flex-column flex-md-row pl-0 mb-0">
                    <li class="py-3 py-md-0 mx-md-3">
                        <router-link to="/projects">Projects</router-link>
                    </li>
                    <li class="py-3 py-md-0 mx-md-3">
                        <router-link to="/about">About</router-link>
                    </li>
                    <li class="py-3 py-md-0 mx-md-3">
                        <router-link to="/contact">Contact</router-link>
                    </li>
                    <li class="py-3 py-md-0 mx-md-3">
                        <hr class="d-md-none">
                        <a href="https://www.instagram.com/studio_chill_chill/" target="_blank">
                            <font-awesome-icon :icon="['fab', 'instagram']" />
                            <img :src="require('../assets/ig_logo.svg')" alt="" style="width: 100%; padding-bottom: 2px;">
                        </a>
                    </li>
                </ul>
            </nav> -->

            <!-- <button class="d-md-none hamburger hamburger--slider" type="button"
            @click="toggleMenu()">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button> -->
        </div>

        <!-- <div class="d-md-none burger-for-slide-block">
            <div class="text-left">
                <h6 class="font-weight-bold mb-0">
                    <router-link to="/">
                        <img :src="require('../assets/icon_logo.svg')" alt="">
                    </router-link>
                </h6>
            </div>

            <button class="d-md-none hamburger hamburger--spring burger-for-slide" type="button" style="padding: 14px 15px;"
            @click="toggleMenu()">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button>
        </div> -->
    </header>

</template>

<script>
export default {
  name: 'Header',
  props: {
    msg: String
  },
  mounted () {
    // $(window).scroll(function () {
    //   var scrollVal = $(this).scrollTop()
    //   console.log(scrollVal);
    //   if (scrollVal >= 64) {
    //     $('body').addClass('show-nav')
    //   } else {
    //     $('body').removeClass('show-nav')
    //   }
    // })
  },
  methods: {
    toggleMenu () {
      $('.header').toggleClass('active')
      $('.hamburger').toggleClass('is-active')
      // window.scrollTo(0, 0);
      // console.log('toggle');
    }
  },
  watch: {
    '$route': function (to, from) {
      // console.log(to, from);
      if (to.path != from.path) {
        $('.header').removeClass('active')
        $('.menubar-ul').removeClass('active')
        $('.hamburger').removeClass('is-active')
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
    h6
        a
            font-size: 0.9rem
            color: rgba(0,0,0,0.9)
            &:hover
                text-decoration: none
    li
        list-style: none
        a
            font-size: 16px
            color: rgba(0,0,0,0.9)
            letter-spacing: 0.5px
            @media screen and (max-width: 767px)
                font-size: 20px
            &:hover
                text-decoration: none
    .header
        position: absolute
        // position: fixed
        // position: relative
        top: 0
        width: 100%
        z-index: 10
        // background-color: #fefefe
        @media screen and (max-width: 767px)
            display: flex
            position: absolute
            width: 100vw
            // background-color: #fefefe
            &.active
                z-index: 10
                position: fixed
                top: 0
                .menubar
                    display: flex
                    top: 0
                    width: 100%
                    ul
                        top: 0
                        display: block
        .burger-for-slide-block
            position: fixed
            width: 100%
            z-index: 10
            padding: 20px
            top: -100%
            left: 0
            transition: top .8s
            background-color: #fcfcfc
        .hamburger
            position: absolute
            right: 5px
            top: 5px
            transform: scale(.7)
            padding: 10px 15px
            .hamburger-box
                width: 30px
                .hamburger-inner, .hamburger-inner::before, .hamburger-inner::after
                    height: 1px
                    width: 30px
        .hamburger.burger-for-slide
            right: 5px
            top: 5px
        .menubar
            ul
                li
                    &:last-child
                        a
                            width: 16px
                            display: block
            @media screen and (max-width: 767px)
                ul
                    height: calc(100vh - 84px)
                    margin-top: 37%
                    top: 100vh
                    width: 100%
                    position: relative
                    transition: top 0.5s
                    display: none
                    li
                        height: 15%
                        &:last-child
                            hr
                                position: absolute
                                left: 0
                                right: 0
                                margin: auto
                                bottom: 45%
                            a
                                position: absolute
                                left: 0
                                right: 0
                                margin: auto
                                bottom: 28%
                                width: 24px
                                svg
                                    transform: scale(1.5)
    button
        &:focus
            outline: 0px auto transparent
    body.show-nav
        .burger-for-slide-block
            position: fixed
            top: 0

</style>
